<template>
  <div>
    <page id="printDiv" size="A4">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h3 class="mx-4 my-8"> Pending Work Order List </h3>
        <vs-table
          style="zoom: 80%;"
          id="wo-list-table"
          :data="work_order_list"
          stripe class="table-dark-inverted table-auto vs-con-loading__container mx-4">
          <template slot="thead">
            <vs-th class="text-xs" width="15%" >WORK ORDER CODE</vs-th>
            <vs-th class="text-xs" >ITS PRODUCT CODE</vs-th>
            <vs-th class="text-xs" >ITS PRODUCT NAME</vs-th>
            <vs-th class="text-xs" >TYPE</vs-th>
            <vs-th class="text-xs" >ORDERS</vs-th>
            <vs-th class="text-xs" >MANUFACTURE DATE</vs-th>
            <vs-th class="text-xs" >SCHEDULED START TIME - END TIME</vs-th>
            <vs-th class="text-xs" >WO STATUS</vs-th>
            <vs-th class="text-xs" >DELIVERY DUE DATE</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>{{tr.work_order_code}}</vs-td>
              <vs-td>{{tr.formulation_code}}</vs-td>
              <vs-td>{{tr.formulation_name}}</vs-td>
              <vs-td>{{tr.formulation_type}}</vs-td>
              <vs-td>
                <span v-if="tr.order_items.length > 0" v-for="(item, index_item) in tr.order_items" :key="index_item">
                  {{ item.order_code }}
                </span>
                <span v-if="tr.order_items.length === 0">
                  STOCK
                </span>
              </vs-td>
              <vs-td>{{tr.work_order_date}}</vs-td>
              <vs-td>{{tr.start_time}} - {{tr.end_time}}</vs-td>
              <vs-td>{{tr.status}}</vs-td>
              <vs-td>{{tr.required_by}}</vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
    </page>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
const ManufacturingRepository = RepositoryFactory.get('manufacturing');

export default {
  name: "WorkOrderList",
  data() {
    return {
      work_order_list: []
    }
  },
  async mounted() {
    await this.fetchWorkOrderList()
  },
  methods: {
    async fetchWorkOrderList() {
      try {
        const { data } = (await ManufacturingRepository.getWorkOrderListPdfData()).data
        this.work_order_list = data
      } catch (e) {

      }
    }
  }
}
</script>

<style lang="scss">
page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
</style>
